module.exports = __webpack_public_path__ + "img/magtype_LSTM.32b88ab0.png";